.noneOverlay {
    display: none;
}

.defaultOverlay {
    font-size: x-large;
    background-color: rgba(0, 0, 0, .65) !important;
}
